import CriteriaExpressionTemplate from "../../compiled-templates/CriteriaExpressionTemplate";
import * as ts from "../../common/Translator";
import {translateIdAr, translateIdEn} from "../../common/Translator";
import CriteriaWidgetRelationTemplate from "../../compiled-templates/CriteriaWidgetRelationTemplate";
import {getRightHandSideWidget} from "../../common/ExpressionEditUtility";
import * as Operator from "../../constants/Operator";
import * as FieldType from "../../constants/FieldType";
import * as ExpressionRelationship from "../../constants/ExpressionRelationship";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import * as ObjectChecker from "../../common/NamaCommon";
import {areAllEmptyOrNull, isEmptyOrNull, isNullOrUndefined, substringAfter} from "../../common/NamaCommon";
import {parseString, toString} from "../../common/FieldTypesUtils";
import * as widgets from "../../widgets/Widgets";
import {dropDownFiltering, sortData} from "../../widgets/Widgets";
import {defaultCriteriaForFilterField, getValueOf} from "./CriteriaFromFilterField";
import {ListPresenter} from "../../routing/ListPresenter";
import {normalizeArabic} from "../../common/StringUtils";
import {isMobileDevice} from "../../common/GUIUtilities";

export class CriteriaEditorWidget {

    constructor({rootElement, metadata, criteriaFields, oldCriteria, presenter, entityType, owner}) {
        this.filteringGroups = [];
        this.rootElement = rootElement;
        this.criteriaFields = criteriaFields;
        this.metaData = metadata;
        if (oldCriteria)
            this.oldExpressions = oldCriteria.expressions;
        this.presenter = presenter;
        this.entityType = entityType;
        this.owner = owner;
    }

    render() {
        let that = this;
        if (!that.oldExpressions || !that.oldExpressions.length) {
            that.expressionEditorsCount = 1;
            let expressionEditor = new ExpressionEditor(that.expressionEditorsCount, that);
            that.filteringGroups.push(expressionEditor);
            expressionEditor.render();
        }
        else {
            if (that.presenter && that.presenter.view.changeFilteringIcon)
                that.presenter.view.changeFilteringIcon(true);
            that.expressionEditorsCount = that.oldExpressions.length;
            for (let i = 1; i <= that.oldExpressions.length; i++) {
                let expressionEditor = new ExpressionEditor(i, that, that.oldExpressions[i - 1], i == that.oldExpressions.length);
                that.filteringGroups.push(expressionEditor);
                expressionEditor.render();
            }
        }
    }

    fetchCriteriaFieldMetadata(fieldId) {
        let that = this;
        let criteriaField = fetchFieldFromCriteriaFields(fieldId, that.criteriaFields);
        return criteriaField ? criteriaField.metaData : null;

    }

    addConditionsRelationshipPart(expressionIndex) {
        let that = this;
        let criteriaBottom = that.rootElement.find("#criteriaBottom");
        if (!criteriaBottom.length) {
            let relationTemplate = $(CriteriaWidgetRelationTemplate({translateId: ts.translateId}));
            relationTemplate.appendTo(that.rootElement.find("#listScreenCriteria" + expressionIndex).find("#expressionFirstPart" + expressionIndex).find(".row"));
        }
        criteriaBottom = that.rootElement.find("#criteriaBottom");
        let allConditions = criteriaBottom.find("#allConditions");
        let anyCondition = criteriaBottom.find("#anyCondition");
        let showAlways = criteriaBottom.find("#alwaysShowCriteriaPart");
        if (!(that.presenter instanceof ListPresenter)) {
            showAlways.remove();
            criteriaBottom.find("#alwaysShowCriteriaPartLabel").remove();
        } else {
            showAlways.prop('checked', localStorage.getItem("alwaysShowFilterPart") === "true");
            showAlways.click(() => {
                localStorage.setItem("alwaysShowFilterPart", showAlways.prop("checked"));
            })
        }
        if (that.oldExpressions && that.oldExpressions.length) {
            let relation = that.oldExpressions[0].relation;
            if (relation == ExpressionRelationship.AND) {
                allConditions.prop("checked", true);
                anyCondition.prop("checked", false);
            }
            else {
                allConditions.prop("checked", false);
                anyCondition.prop("checked", true);
            }
        }
        allConditions.click(function () {
            let checked = allConditions.prop("checked");
            if (checked)
                anyCondition.prop("checked", false);
            else
                anyCondition.prop("checked", true);
            if (that.owner.updateCriteriaEditorVal)
                that.owner.updateCriteriaEditorVal();
        });
        anyCondition.click(function () {
            let checked = anyCondition.prop("checked");
            if (checked)
                allConditions.prop("checked", false);
            else
                allConditions.prop("checked", true);
            if (that.owner.updateCriteriaEditorVal)
                that.owner.updateCriteriaEditorVal();
        });
        if (!that.presenter) {
            let listBtn = $(`<a id = "list" style="margin-left: 50px;margin-right: 50px"></a>`);
            listBtn.appendTo(criteriaBottom);
            listBtn.kendoButton({
                icon: 'align-justify',
                click: e => {
                    that.applyCriteriaIfExpressions()
                }
            });
        }
    }

    allConditions() {
        let that = this;
        let criteriaBottom = that.rootElement.find("#criteriaBottom");
        let allConditions = criteriaBottom.find("#allConditions");
        return allConditions.prop("checked");
    }

    anyCondition() {
        let that = this;
        let criteriaBottom = that.rootElement.find("#criteriaBottom");
        let anyCondition = criteriaBottom.find("#anyCondition");
        return anyCondition.prop("checked");
    }

    calcCriteria() {
        let owner = this;
        let criteria = new JSCriteriaBuilder();
        criteria.expressions = [];
        if (!owner || !owner.filteringGroups)
            return criteria;
        let relation = ExpressionRelationship.AND;
        if (owner.anyCondition())
            relation = ExpressionRelationship.OR;
        for (let filteringGroup of owner.filteringGroups) {
            if (ObjectChecker.isAnyEmptyOrNull(filteringGroup.fieldIdToFilter(), filteringGroup.fieldOperator()))
                continue;
            let expression = filteringGroup.groupExpression();
            expression.relation = relation;
            criteria.expressions.push(expression)
        }
        return criteria;
    }

    applyCriteriaIfExpressions() {
        let that = this;
        let calcCriteria = that.calcCriteria();
        if (calcCriteria && calcCriteria.expressions && calcCriteria.expressions.length)
            if (that.owner.refresh)
                that.owner.refresh();
            else if (that.owner.updateCriteriaEditorVal)
                that.owner.updateCriteriaEditorVal();
    }
}

export function addArabicEnglishToData(availableOperators, entityType) {
    for (let field of availableOperators) {
        if (entityType) {
            let criteriaField = fetchFieldFromCriteriaFields(field.id, availableOperators);
            field.arabicText = ts.translateTitledIDWithPrefixesAr(criteriaField, entityType);
            field.englishText = ts.translateTitledIDWithPrefixesEn(criteriaField, entityType);
        } else {
            field.arabicText = translateIdAr(field.id);
            field.englishText = translateIdEn(field.id);
        }
        field.searchData = field.id + " " + field.arabicText + " " + field.englishText + " " + normalizeArabic(field.arabicText);
    }
    sortData(availableOperators);
}

export function destroyKendoWidgets(element) {
    kendo.destroy(element);
}

export class ExpressionEditor {
    constructor(expressionIndex, parent, expression, lastExpressionInOldCriteria) {
        this.expressionIndex = expressionIndex;
        this.parentWidget = parent;
        this.metaData = parent.metaData;
        this.criteriaValueWidget = null;
        this.isCriteriaWidget = true;
        this.entityType = parent.entityType;
        this.expression = expression;
        this.lastExpressionInOldCriteria = lastExpressionInOldCriteria;
    }

    render() {
        let that = this;
        let parent = this.parentWidget;
        let criteriaExpression = $(CriteriaExpressionTemplate({groupNumber: that.expressionIndex}));
        criteriaExpression.appendTo(parent.rootElement.find("#listScreenFilteringConditions"));
        that._initExpressionEditorEvents();
        criteriaExpression.parent().find(".listCriteriaRow").addClass("criteriaEditorExpression");
        criteriaExpression.removeClass("criteriaEditorExpression");
        if (that.expression)
            that.fillExpressionWidgets(true);
        return criteriaExpression;
    }

    rootElement() {
        return this.parentWidget.rootElement.find("#listScreenCriteria" + this.expressionIndex);

    }

    fieldIdToFilter() {
        let fieldIdData = this.rootElement().find("#expressionFirstPart" + this.expressionIndex).find("#field" + this.expressionIndex).data("kendoDropDownList");
        return fieldIdData ? fieldIdData.value() : null;
    }

    fieldOperator() {
        let operatorData = this.rootElement().find("#expressionOperatorPart" + this.expressionIndex).find("#operator" + this.expressionIndex).data("kendoDropDownList");
        return operatorData ? operatorData.value() : null;
    }

    fieldValue() {
        let that = this;
        if (!that.filterFieldElement().length)
            return undefined;
        let fieldId = that.filterFieldElement().data("kendoDropDownList").value();
        if (isEmptyOrNull(fieldId))
            return undefined;
        let fieldMetaData = that.parentWidget.fetchCriteriaFieldMetadata(fieldId);
        //Changed from readValueFromElementForQuestionField to readValueFromElement because of criteria widget date field problem
        // ticket #SRDRQ02917
        return toString(fieldMetaData.fieldType, this.criteriaValueWidget.readValueFromElement());
    }

    groupExpression() {
        let that = this;
        let value = that.fieldValue();
        value = isNullOrUndefined(value) ? null : value;
        return {field: that.fieldIdToFilter(), operator: that.fieldOperator(), rightHandSide: value};
    }

    criteriaBtnElement() {
        let that = this;
        return that.rootElement().find("#addCriteria" + that.expressionIndex);
    }

    copyCriteriaBtnElement() {
        let that = this;
        return that.rootElement().find("#copyCriteria" + that.expressionIndex);
    }

    filterFieldElement() {
        let that = this;
        return that.rootElement().find("#expressionFirstPart" + that.expressionIndex).find("#field" + that.expressionIndex);
    }

    operatorElement() {
        let that = this;
        return that.rootElement().find("#expressionOperatorPart" + that.expressionIndex).find("#operator" + that.expressionIndex);
    }

    onDataChanged() {
        let that = this;
        that.parentWidget.applyCriteriaIfExpressions();
    }


    _initExpressionEditorEvents() {
        let that = this;
        let addCriteriaBtn = that.criteriaBtnElement();
        let copyCriteriaBtn = that.copyCriteriaBtnElement();
        copyCriteriaBtn.kendoButton({
            icon: 'copy',
            click: function (e) {
                let expressionIndexToCopy = substringAfter($(e.event.target).attr("id"), "copyCriteria");
                let filteringGroups = that.parentWidget.filteringGroups;
                let currExpression = filteringGroups.filter(g => g.expressionIndex == expressionIndexToCopy)[0];
                if (!currExpression)
                    return;
                let expression = currExpression.groupExpression();
                if (areAllEmptyOrNull(expression.field, expression.operator, expression.rightHandSide))
                    return;
                let addCriteriaBtn = that.parentWidget.rootElement.find("#addCriteria" + that.parentWidget.expressionEditorsCount);
                addCriteriaBtn.trigger("click");
                let newFilteringGroup = filteringGroups[filteringGroups.length - 2];
                if (newFilteringGroup) {
                    newFilteringGroup.expression = expression;
                    newFilteringGroup.fillExpressionWidgets();
                }

            }
        });
        addCriteriaBtn.kendoButton({
            icon: 'plus',
            id: " addCriteria",
            click: function (e) {
                let element = this.element;
                let icon = element.children(".k-icon");
                let expanded = element.attr("expanded");
                if (expanded == "true") {
                    if (that.parentWidget.filteringGroups.length == 2) {
                        that.removeConditionsRelationshipPart();
                    }
                    destroyKendoWidgets($(element).closest(".listCriteriaRow"));
                    that.rootElement().remove();
                    let index = that.parentWidget.filteringGroups.indexOf(that);
                    if (index > -1) {
                        that.parentWidget.filteringGroups.splice(index, 1);
                    }
                }
                else {
                    that.parentWidget.expressionEditorsCount++;

                    element.attr("expanded", true);
                    icon.removeClass("k-i-plus");
                    icon.addClass("k-i-minus");
                    copyCriteriaBtn.css("display", "block");
                    that.addCriteriaParts();
                    if (!that.expression || that.lastExpressionInOldCriteria) {
                        let screenFilterGroup = new ExpressionEditor(that.parentWidget.expressionEditorsCount, that.parentWidget);
                        that.parentWidget.filteringGroups.push(screenFilterGroup);
                        screenFilterGroup.render();
                    }
                    if (that.parentWidget.expressionEditorsCount > 1) {
                        that.removeConditionsRelationshipPart();
                        that.parentWidget.addConditionsRelationshipPart(that.parentWidget.expressionEditorsCount);
                    }
                }
                if (that.parentWidget.presenter && that.parentWidget.presenter.view && that.parentWidget.presenter.view.changeFilteringIcon) {
                    that.parentWidget.presenter.view.changeFilteringIcon(that.parentWidget.filteringGroups.length > 1);
                }
                if (that.parentWidget.owner.setHeightOfListViewGrid)
                    that.parentWidget.owner.setHeightOfListViewGrid();
                if (that.parentWidget.owner.updateCriteriaEditorVal)
                    that.parentWidget.owner.updateCriteriaEditorVal();
            }
        });
    }

    removeConditionsRelationshipPart() {
        let that = this;
        let criteriaBottom = that.parentWidget.rootElement.find("#criteriaBottom");
        criteriaBottom.remove();
    }

    hideFilteringComponents() {
        let that = this;
        that.filterFieldElement().remove();
        that.operatorElement().remove();
        if (that.criteriaValueWidget)
            that.criteriaValueWidget.remove();
    }

    getPlaceExtraFieldFilterId() {
        //TODO: gui 2 missing feature
    }

    addDataWidget(widget) {
        this.criteriaValueWidget = widget;
    }

    getFieldValue(fieldId, row) {
        return null;
    }

    setFieldValue(fieldId, value, row) {
    }

    fillExpressionWidgets(withAddBtnClick) {
        let that = this;
        if (withAddBtnClick) {
            let addCriteriaBtn = that.criteriaBtnElement();
            addCriteriaBtn.trigger("click");
        }
        /**
         * @type {namaTypes.DTOExperssion}
         */
        let expression = that.expression;
        let fieldToFilterList = that.filterFieldElement();
        fieldToFilterList.data("kendoDropDownList").value(expression.field);
        fieldToFilterList.data("kendoDropDownList").trigger("change");
        let operator = that.operatorElement();
        operator.data("kendoDropDownList").value(expression.operator);
        let fieldMetaData = that.parentWidget.fetchCriteriaFieldMetadata(expression.field);
        if (that.criteriaValueWidget instanceof widgets.ReferenceWidget)
            that.criteriaValueWidget.oldValue = parseString(expression.rightHandSide, fieldMetaData.fieldType);
        that.criteriaValueWidget.setValueInElement(parseString(expression.rightHandSide, fieldMetaData.fieldType));
    }

    addCriteriaParts() {
        let that = this;
        let valueWidget = that.criteriaValueWidget;
        let criteriaExpression = that.rootElement();
        let fieldToFilter = $(`<div class="col-lg-10 col-md-6 col-sm-6 col-xs-6"><select id="field${that.expressionIndex}" class="full-width" nid="field"/></div>`);
        let operatorField = $(`<select id="operator${that.expressionIndex}" class="full-width" nid="operator"/>`);
        let expressionFirstPart = criteriaExpression.find("#expressionFirstPart" + that.expressionIndex);
        let expressionOperatorPart = criteriaExpression.find("#expressionOperatorPart" + that.expressionIndex);
        fieldToFilter.appendTo(expressionFirstPart.find(".row"));
        operatorField.appendTo(expressionOperatorPart);
        that.model = kendo.data.Model.define({});
        Object.defineProperty(that.model.prototype, "$translatedId", {
            enumerable: false, configurable: true, get: function () {
                return ts.translateId(this.id);
            }, set: function (value) {
            }
        });
        Object.defineProperty(that.model.prototype, "$translatedFieldId", {
            enumerable: false, configurable: true, get: function () {
                let criteriaField = fetchFieldFromCriteriaFields(this.id, that.parentWidget.criteriaFields);
                return ts.translateTitledIDWithPrefixes(criteriaField, that.entityType);
            }, set: function (value) {
            }
        });
        addArabicEnglishToData(that.parentWidget.criteriaFields, that.entityType);
        fieldToFilter.find("#field" + that.expressionIndex).kendoDropDownList({
            filter: "contains",
            optionLabel: " ",
            dataSource: new kendo.data.DataSource({
                data: that.parentWidget.criteriaFields,
                schema: {
                    model: that.model
                }
            }),
            autoWidth: true,
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
            change: function (e) {
                criteriaExpression.find(".criteriaWidgetContainer").remove();
                operatorField.data("kendoDropDownList").dataSource.read();
                operatorField.data("kendoDropDownList").value(Operator.Equal);
                let fieldId = that.filterFieldElement().data("kendoDropDownList").value();
                let fieldMetaData = that.parentWidget.fetchCriteriaFieldMetadata(fieldId);
                valueWidget = getRightHandSideWidget({id: fieldId, metaData: fieldMetaData}, that);
                valueWidget.removeClass("form-widgets");
                valueWidget.addClass("criteriaWidgetContainer");
                valueWidget.addClass("expression-widget-mobile");
                valueWidget.addClass("col-lg-6");
                valueWidget.addClass("col-md-6");
                valueWidget.addClass("col-sm-12");
                valueWidget.addClass("col-xs-12");
                let childrenLength = valueWidget.find(".form-group").children().length;
                if (childrenLength && childrenLength > 1)
                    valueWidget.find(".form-group").addClass("row");
                valueWidget.appendTo(criteriaExpression);
                let criteriaField = fetchFieldFromCriteriaFields(fieldId, that.parentWidget.criteriaFields);
                if (criteriaField.domainClassName)
                    that.criteriaValueWidget.domainClassName = criteriaField.domainClassName;
                that.criteriaValueWidget.afterAttach();
                that.criteriaValueWidget.defaultCriteria = () => defaultCriteriaForFilterField(criteriaField, that.entityType, (ref) => getValueOf(ref, that.parentWidget.calcCriteria()));
                that.criteriaValueWidget.findElement().on("keypress", (e) => {
                    if (e.keyCode === kendo.keys.ENTER) {
                        that.parentWidget.applyCriteriaIfExpressions();
                    }
                });
                if (that.parentWidget.owner.updateCriteriaEditorVal)
                    that.parentWidget.owner.updateCriteriaEditorVal();
            }
        });
        operatorField.kendoDropDownList({
            filter: "contains",
            optionLabel: " ",
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: (options) => {
                        let availableOperators = getAvailableOperators(that.fieldIdToFilter(), that.parentWidget.criteriaFields);
                        addArabicEnglishToData(availableOperators);
                        options.success(availableOperators);
                    }
                },
                schema: {
                    model: that.model
                }
            }),
            dataTextField: "$translatedId",
            dataValueField: "id",
            autoWidth: true,
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
            change: function (e) {
                if (that.parentWidget.owner.updateCriteriaEditorVal)
                    that.parentWidget.owner.updateCriteriaEditorVal();
            }
        });
    }
}

function getAvailableOperators(fieldId, availableFilters) {
    let operators = [{id: Operator.Equal}, {id: Operator.NotEqual}];
    let filterField = fetchFieldFromCriteriaFields(fieldId, availableFilters);
    if (!filterField || !filterField.metaData.fieldType)
        return operators;
    let fieldType = filterField.metaData.fieldType;
    switch (fieldType) {
        case FieldType.BigText:
        case FieldType.Text:
        case FieldType.Link:
        case FieldType.Email:
        case FieldType.FieldID:
        case FieldType.FeatureID:
        case FieldType.LongToken:
        case FieldType.PhoneNumber:
        case FieldType.Password:
        case FieldType.LatLng:
        case FieldType.Color:
            operators = [{id: Operator.Equal}, {id: Operator.NotEqual}, {id: Operator.StartsWith}, {id: Operator.EndsWith}, {id: Operator.Contains},
                {id: Operator.GreaterThan}, {id: Operator.GreaterThanOrEqual}, {id: Operator.LessThan}, {id: Operator.LessThanOrEqual}
                , {id: Operator.NotContain}, {id: Operator.NotStartsWith}, {id: Operator.NotEndWith}];
            break;
        case FieldType.Integer:
        case FieldType.Decimal:
        case FieldType.Long:
        case FieldType.Date:
        case FieldType.DateAndTime:
        case FieldType.Time:
            operators = [{id: Operator.Equal}, {id: Operator.NotEqual}, {id: Operator.GreaterThan}, {id: Operator.GreaterThanOrEqual}
                , {id: Operator.LessThan}, {id: Operator.LessThanOrEqual}];
            break;
        case FieldType.Boolean:
            operators = [{id: Operator.Equal}];
            break;
        case FieldType.Reference:
        case FieldType.EntityType:
        case FieldType.Enum:
            operators = [{id: Operator.Equal}, {id: Operator.NotEqual}];
            break;
    }
    return operators;
}

export function fetchFieldFromCriteriaFields(fieldId, criteriaFields) {
    for (let filterField of criteriaFields) {
        if (fieldId === filterField.id)
            return filterField;
    }
    return null;
}